export const renderActionIcon = (action, onlineStatus) => {
  switch (action) {
    case 'delete':
      return 'fa-solid fa-trash';
    case 'onlineOffline':
      if (onlineStatus) {
        return 'fa-light fa-video-slash';
      } else return 'fa-solid fa-video';
    case 'edit':
      return 'fa-solid fa-edit';
  }
};
